const locationError = {
  alert: 'Habilite o serviço de localização deste site nas configurações do navegador',
  else: 'Não foi possível acessar à sua localização',
  else1: 'Serviço de Geolocalização não disponível no seu navegador'
};

export default locationError;
